export default {
  // 對話框標題
  title: "添加標籤",

  // 表單相關
  pleaseSelect: "請選擇",
  pleaseInput: "請輸入",
  pleaseInputContent: "請輸入內容",

  // 按鈕
  cancel: "取 消",
  confirm: "確 定",

  // 驗證消息
  requiredFieldError: "*號為必填項",
  addLabelSuccess: "此數據已成功打上該標籤",
};
